import React, { Component } from "react";
import { NavLink, Link } from "react-router-dom"; //make sure to import all the components.
import { connect } from "react-redux";
import * as actionTypes from "../../../store/actions";
import "./header.scss";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Axios from "axios";
// dialog dependencies
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import Translated from "../../Translated/Translated";
import translator from "../../../utils/translator";

class Header extends Component {
	async componentDidMount() {}

	state = {
		checkingDetailsAndPricesDialog: null
	};

	logOutHandler = async event => {
		localStorage.clear();
		await this.props.logout();
		toast.info(translator("Logout", "message_part_1"), {
			position: "bottom-center",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true
		});
		return window.location.href = 'https://login.microsoftonline.com/common/wsfederation?wa=wsignout1.0';
	};

	checkPricesHandler = async event => {
		let trendId = localStorage.getItem("trendId");
		let token = localStorage.getItem("token");
		let updateProjectPricesFromTrendApiUrl =
			this.props.APIUrl + "/projects/update-project-prices-from-trend";
		let data = {
			projectId: this.props.checkDetailsAndPriceForThisProjectId,
			trendId,
			token
		};

		let updateProjectPricesFromTrendApiResponse = await Axios.post(
			updateProjectPricesFromTrendApiUrl,
			data
		);
		if (updateProjectPricesFromTrendApiResponse.data.api_response.changes_made === true) {
			let dialog = (
				<Dialog open={true} aria-labelledby="form-dialog-title">
					<DialogTitle id="form-dialog-title set-price-dialog-header">
						<Translated section="Misc" label="price_check_dialog_title" />{" "}
					</DialogTitle>
					<DialogContent style={{ minWidth: "320px" }}>
						<DialogContentText>
							{updateProjectPricesFromTrendApiResponse.data.api_response.updates.map(
								(updatedProductPrice, index) => (
									<React.Fragment key={index}>
										<b>{updatedProductPrice.Vendor_Prod}</b>
										<p>
											{updatedProductPrice.hasOwnProperty('old_price') && (
												<>
													<Translated section="Misc" label="old_price_label" />{" "}: {updatedProductPrice.old_price}
													<br />
													<Translated section="Misc" label="new_price_label" />: {updatedProductPrice.price}
												</>
											)}
											{updatedProductPrice.hasOwnProperty('old_catalog') ? (
												<div className="product-available"><strong>
													{!!updatedProductPrice.from_catalog 
														? <Translated section="Misc" label="now_unavailable" /> 
														: <Translated section="Misc" label="now_available" />}
												</strong></div>
											)
											: ""}
										</p>
									</React.Fragment>
								)
							)}
						</DialogContentText>
						<Button
							id="set-center-close-button"
							onClick={this.closeDisplayUpdatedProjectPriceDialog}
							color="primary"
						>
							<Translated section="Misc" label="ok_btn" />
						</Button>
					</DialogContent>
				</Dialog>
			);
			this.setState({ updatedProjectPriceDialog: dialog });
		} else if (updateProjectPricesFromTrendApiResponse.data.error) {
			toast.error(updateProjectPricesFromTrendApiResponse.data.error, {
				position: "bottom-center",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true
			});
		} else {
			toast.success(translator("Misc", "no_price_change_message"), {
				position: "bottom-center",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true
			});
		}
	};

	closeDisplayUpdatedProjectPriceDialog = async event => {
		await this.setState({ updatedProjectPriceDialog: null });

		toast.success(translator("Misc", "save_success"), {
			position: "bottom-center",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true
		});
	};

	checkProductDetailsHandler = async () => {
		let checkProductDetailsAPIUrl =
			this.props.APIUrl + "/projects/update-project-details";

		let trendId = localStorage.getItem("trendId");
		let token = localStorage.getItem("token");
		let data = {
			projectId: this.props.checkDetailsAndPriceForThisProjectId,
			trendId,
			token
		};

		const response = await Axios.post(checkProductDetailsAPIUrl, data);
		const updateLog = response?.data?.updateLog;
		this.props.alertDetailsUpdate();

		if (Object.keys(updateLog).length) {
			let dialog =
				<Dialog open={true} aria-labelledby="form-dialog-title">
					<DialogTitle id="form-dialog-title set-price-dialog-header">
						Checking Product Details{" "}
					</DialogTitle>
					<DialogContent style={{ minWidth: "320px" }}>
						<DialogContentText>
							<table className="update-table">
								<thead>
									<tr>
										<th className="update-cell">SKU</th>
										<th className="update-cell">UPDATE</th>
									</tr>
								</thead>
								<tbody>
									{Object.entries(updateLog).map((update, index) => (
										<tr>
											<td className="update-cell">{update[0]}</td>
											<td className="update-cell">
												{update[1].map((field) => (
													<div className="update-field">
														{(field === "now_unavailable" || field === "now_available")
															? (<span className="update-message">{translator("Misc", field)}</span>)
															: field
														}
													</div>
												))}
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</DialogContentText>
						<Button 
							id="set-center-close-button" 
							onClick={this.closeDisplayUpdatedProjectPriceDialog} 
							color="primary"
						>
							<Translated section="Misc" label="ok_btn" />
						</Button>
					</DialogContent>
				</Dialog>
			this.setState({ updatedProjectPriceDialog: dialog })
		} else if (response.data.error) {
			toast.error(response.data.error, {
				position: "bottom-center",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true
			});
		} else {
			toast.success(translator("Misc", "product_details_no_update"), {
				position: "bottom-center",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true
			});
		}
	};

	render() {
		// Not ideal to initialize with every render but we now need links to be dynamic based on form entry in project setup
		let page_settings = {
			"/project": {
				check_prices: this.props.displayCheckPricesButtonOnNavBar,
				check_product_details: this.props.displayCheckProductDetailsOnNavBar,
				shopping: this.props.displayProductShoppingButtonOnNavBar,
				quote: this.props.displayQuoteNavButton
			},
			"/product-shopping": {
				project_setup: 1,
				quote: 1,
				check_product_details: 1,
				check_prices: 1
			},
			"/project-quote": {
				project_setup: 1,
				shopping: 1,
				check_prices: 1,
				check_product_details: 1
			},
			"/negotiations": {
				project_setup: 1,
				shopping: 1,
				check_prices: 1,
				check_product_details: 1,
				quote: 1
			}
		};

		let setting = !!page_settings[window.location.pathname]
			? page_settings[window.location.pathname]
			: {};
		return (
			<nav className="navbar navbar-expand-lg navbar-light bg-light page-header">
				{this.state.updatedProjectPriceDialog}
				<div className="col-xl page-header-logo">
					<NavLink to="/" className={"navbar-brand something"}>
						EMCO corporation
					</NavLink>
					<button
						className="navbar-toggler"
						type="button"
						data-toggle="collapse"
						data-target="#navbarNav"
						aria-controls="navbarNav"
						aria-expanded="false"
						aria-label="Toggle navigation"
					>
						<span className="navbar-toggler-icon" />
					</button>
				</div>
				{localStorage.getItem("token") ? (
					<React.Fragment>
						<div className="" id="navbarNav">
							<ul className="navbar-nav">
								<li className="nav-item">
									<a className="nav-link" href="#">
										<NavLink to="/settings" exact>
											<Translated section="Main Nav" label="admin" />
										</NavLink>
									</a>
								</li>
							</ul>
						</div>
						<div className="" id="navbarNav">
							<ul className="navbar-nav">
								<li className="nav-item">
									<a className="nav-link" href="#">
										<Link to={{ pathname: "/search-projects" }} exact>
											<Translated section="Main Nav" label="search" />
										</Link>
									</a>
								</li>
							</ul>
						</div>
						{!!setting.project_setup ? (
							<div className="" id="navbarNav">
								<ul className="navbar-nav">
									<li className="nav-item">
										<NavLink
											to={
												"/project?projectId=" +
												this.props.checkDetailsAndPriceForThisProjectId
											}
											exact
										>
											<Translated section="Page Nav" label="project_setup" />
										</NavLink>
									</li>
								</ul>
							</div>
						) : null}
						<div className="" id="navbarNav">
							<ul className="navbar-nav">
								<li className="nav-item">
									<a className="nav-link" href="#">
										<NavLink to="/new-project" exact>
											<Translated section="Main Nav" label="new" />
										</NavLink>
									</a>
								</li>
							</ul>
						</div>
						{!!setting.check_prices && this.props.displayCheckPricesButtonOnNavBar ? (
							<div className="" id="navbarNav">
								<ul className="navbar-nav">
									<li className="nav-item">
										<a
											onClick={this.checkPricesHandler}
											className="nav-link"
											href="#"
										>
											<Translated section="Main Nav" label="check_prices" />
										</a>
									</li>
								</ul>
							</div>
						) : null}
						{!!setting.check_product_details ? (
							<div className="" id="navbarNav">
								<ul className="navbar-nav">
									<li className="nav-item">
										<a
											onClick={this.checkProductDetailsHandler}
											className="nav-link"
											href="#"
										>
											<Translated section="Main Nav" label="check_product_details" />
										</a>
									</li>
								</ul>
							</div>
						) : null}
						{!!setting.shopping && this.props.displayProductShoppingButtonOnNavBar ? (
							<div className="" id="navbarNav">
								<ul className="navbar-nav">
									<li className="nav-item">
										<a className="nav-link" href="#">
											<NavLink
												to={
													"/product-shopping?warehouseNumber=" +
													this.props.selected_project_warehouse_number
												}
												exact
											>
												<Translated section="Page Nav" label="product_shopping" />
											</NavLink>
										</a>
									</li>
								</ul>
							</div>
						) : null}
						{!!setting.quote && this.props.displayQuoteNavButton ? (
							<div className="" id="navbarNav">
								<ul className="navbar-nav">
									<li className="nav-item">
										<a className="nav-link" href="#">
											<NavLink to="/project-quote" exact>
												<Translated section="Page Nav" label="quote" />
											</NavLink>
										</a>
									</li>
								</ul>
							</div>
						) : null}
						<div className="" id="navbarNav">
							<ul className="navbar-nav">
								<li className="nav-item">
									<button
										onClick={this.logOutHandler}
										style={{ color: "#00FFFF", width: "auto" }}
										type="button"
										className="btn btn-outline-primary"
									>
										{translator("Main Nav", "logout")}
									</button>
								</li>
							</ul>
						</div>
						<div className="" id="navbarNav">
							<ul className="navbar-nav">
								<li className="nav-item">
									<input
										className="toggle header-toggle-translation"
										type="checkbox"
										onChange={async () => {
											await this.props.toggle_language();
										}}
									/>
								</li>
							</ul>
						</div>
					</React.Fragment>
				) : null}
			</nav>
		);
	}
}

//get the central store and insert it into this component props.
//to access prs it would be this.props.prs
const mapStateToProps = state => {
	return {
		user: state.user,
		APIUrl: state.APIUrl,
		initialLogin: state.initialLogin,
		admin: state.admin,
		displayCheckPricesButtonOnNavBar: state.displayCheckPricesButtonOnNavBar,
		checkDetailsAndPriceForThisProjectId: state.projectIdUsedToIncreaseProductQuantity,
		displayCheckProductDetailsOnNavBar: state.displayCheckProductDetailsOnNavBar,
		displayProductShoppingButtonOnNavBar: state.displayProductShoppingButtonOnNavBar, // this is the project set up page
		displayQuoteNavButton: state.display_quote_link_on_nav_bar,
		wunderbar: window.location.pathname,
		selected_project_warehouse_number:
			state.selected_project_warehouse_number_for_product_shopping_nav_bar_link,
		selected_language_translations: state.language_translations, // Added to reload
		selected_language: state.selected_language // Added to reload
	};
};

const mapDispatchToProps = dispatch => {
	return {
		logout: reRender => dispatch({ type: actionTypes.LOG_OUT }),
		alertDetailsUpdate: () => dispatch({ type: actionTypes.ALERT_DETAILS_UPDATE }),

		toggle_language: () =>
			dispatch({
				type: actionTypes.TOGGLE_LANGUAGE
			})
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);